import { render, staticRenderFns } from "./SimpleWord.vue?vue&type=template&id=8a1fd4be"
import script from "./SimpleWord.vue?vue&type=script&lang=js"
export * from "./SimpleWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports